import { EventBus } from './event-bus'
const axios = require('axios')

function getUri(uri, config, lastRun){
	let query = []

	if(lastRun){
		query.push('lastRun=' + lastRun)
	}

	if(config.user.profile.group){
		let owner
		switch (config.user.profile.group) {
		case '990bab1f-ce1f-46c0-b144-9675c7db6ec0':
			owner = 'OHC'
			break
		default:
			break
		}
		if(owner){
			query.push('owner=' + owner)
		}
	}

	if(query.length){
		uri += '?'
		query.forEach((item, index)=>{
			if(index > 0){
				uri += '&'
			}
			uri += item
		})
	}

	return uri
}

const catalogClient = {
	getProducts(config, lastRun) {
		let headers = {}
		let uri
		if (process.env.VUE_APP_MOCK_GATEWAY === 'true') {
			uri = getUri('./../json/allProducts.json', config, lastRun)
			console.info('%cGet test products from: ' + uri , 'background: #f8ff96; padding:3px')
		} else {
			uri = getUri(`${config.uri}api/products`, config, lastRun)
			headers = {
				Accept: 'application/json',
				Authorization: 'Bearer ' + config.access_token,
				'X-Environment': config.env,
				'X-Version': config.appVersion
			}
		}
		return new Promise((resolve, reject) => {
			axios
				.get(uri, {
					method: 'GET',
					url: uri,
					headers,
					onDownloadProgress: function (progressEvent) {
						let total = progressEvent.total
						let loadingPercentage = 0
						if(total > 0){
							loadingPercentage = Math.round((progressEvent.loaded/progressEvent.total)*100)
						}

						EventBus.$emit('loadingStatus', {
							type: 'downloadProducts',
							loadingPercentage
						})
					},
				})
				.then(
					response => {
						resolve(response.data)
					},
					error => {
						reject(error)
					}
				)
		})

	},
	getClients(config, lastRun) {
		let uri
		let headers = {}
		if (process.env.VUE_APP_MOCK_GATEWAY === 'true') {
			console.info('%cGet test clients', 'background: #f8ff96; padding:3px')
			uri = './../json/allClientsAndLocations.json'
		} else {
			headers = {
				Accept: 'application/json',
				Authorization: 'Bearer ' + config.access_token,
				'X-Environment': config.env,
				'X-Version': config.appVersion
			}
			uri = `${config.uri}api/clients`
			if (lastRun) uri += '?lastRun=' + lastRun
		}

		return new Promise((resolve, reject) => {
			axios
				.get(uri, {
					method: 'GET',
					url: uri,
					headers,
					onDownloadProgress: function (progressEvent) {
						let total = progressEvent.total
						let loadingPercentage = 0
						if(total > 0){
							loadingPercentage = Math.round((progressEvent.loaded/progressEvent.total)*100)
						}
						EventBus.$emit('loadingStatus', {
							type: 'downloadClients',
							loadingPercentage
						})
					},
				})
				.then(
					response => {
						resolve(response.data)
					},
					error => {
						reject(error)
					}
				)
		})
	}
}

export { catalogClient }
